import { Divider, ListItemText } from "@mui/material";
import { StyledListItem } from "./styles";
import { ReactNode } from "react";

interface ListRowProps {
    id?: string;
    text: ReactNode;
    action?: ReactNode;
    icon: ReactNode;
}

export default function ListRow({id, text, action, icon}: ListRowProps) {
    return (
        <StyledListItem
          key={id}
          secondaryAction={action}
        >
            {icon}
            <ListItemText>
                {text}
            </ListItemText>
        </StyledListItem>
    );
}